import { render, staticRenderFns } from "./customize.vue?vue&type=template&id=4ddbeabe&scoped=true&"
import script from "./customize.vue?vue&type=script&lang=js&"
export * from "./customize.vue?vue&type=script&lang=js&"
import style0 from "./customize.vue?vue&type=style&index=0&id=4ddbeabe&prod&lang=scss&scoped=true&"
import style1 from "./customize.vue?vue&type=style&index=1&id=4ddbeabe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddbeabe",
  null
  
)

export default component.exports